<template>
    <li :class="[isInput ? classOject.input : classOject.token,'token-type-'+token.type]">
        <div class="selectable" role="button" v-if="!isInput" v-on:click="selected">
            <div class=" name">{{displayTokenType}}</div>
            <div class="value-container" data-original-value="@biwer-r" v-if="!active">
                <div class="value">
                    {{displayTokenValue}}
                </div>
                <div class="remove-token" role="button" v-on:click="removed" v-show="!active">
                    <i class="glyphicon glyphicon-remove"></i>
                </div>
            </div>
        </div>
        <input autocomplete="off" class="form-control filtered-search" ref="tokenInput"
               v-if="isInput"
               v-model="token.value"
               v-on:blur="blurred"
               v-on:input="input($event)"
               v-on:keydown="keydown($event)"
               v-on:keyup="keyup($event)"
        >

        <visual-token-dropdown :elem="tokenInput" :input="token.value" :resultConfig="resultConfig" :results="results"
                               @inactive="state.isDropdownEnabled=false"
                               @active="state.isDropdownEnabled=true"
                               @select="dropdownSelection($event)"></visual-token-dropdown>

    </li>
</template>


<script>

    import axios from 'axios';
    import lodash from 'lodash';
    import VisualTokenDropdown from "./VisualTokenDropdown";

    const displayNames = {
        'assignee': 'Author',
        'category': 'Kategorie',
        'product': 'Produkt',
        'type': 'Typ'
    };

    const valueLookup = {
        "category": {
            "165554": "Fenstersysteme"
        }
    };


    export default {
        props: [
            'lookup', 'token', 'select', 'remove', 'active', 'blur', 'resultConfig'
        ],
        components: {
            VisualTokenDropdown
        },
        data: function () {
            return {
                state: {
                    isLoading: false,
                    isOpen: false,
                    isDropdownEnabled: false,
                },
                tokenInput: null,
                results: [],
                currentResultIndex: null,
                classOject: {
                    input: "input-token",
                    token: "js-visual-token filtered-search-token"
                }
            }
        },
        computed: {
            isInput() {
                return this.token.type === 'input';
            },
            displayTokenType() {
                if (this.isInput)
                    return "";
                return displayNames[this.token.type]
            },
            displayTokenValue() {
                if (!valueLookup[this.token.type])
                    return this.token.value;
                var value = valueLookup[this.token.type][this.token.value];

                return value ? value : this.token.value;
            }
        },
        methods: {
            submit() {
                this.tokenInput.blur();
                this.$emit('submit');
            },
            async updateDropdown() {
                let input = this.token.value;

                if (!input)
                    return;
                try {

                    let results = await new Promise((resolve, reject) => {
                        axios.post(process.env.VUE_APP_API_BASE + '/api/service/search/autocomplete', {
                            //'filter': $this.filterSelection,
                            //'selection': $this.getSelectionPath(),
                            'query': input,
                            'locale': window.locale
                        }).then((response) => {
                            resolve(response.data.results);
                        });
                    });

                    this.results = results;
                } catch (e) {
                    this.results = [];
                }
            },
            focusInput() {
                this.$refs.tokenInput.focus();
            },
            selected() {
                this.select(this.token)
            },
            removed() {
                this.$emit('token:remove', this.token);
            },
            blurred() {
                if (this.isInput)
                    this.blur(this.token);
            },
            input(e) {
                let $this = this;
                this.throttleInput(this);
            },
            throttleInput: lodash.debounce(($this) => {
                if ($this.token.value.length > 3)
                    $this.updateDropdown();
            }, 500),
            keydown(e) {

            },
            dropdownSelection(e) {
                this.token.value = e.term ? e.term : e.fields.title[0];

                if (!e.term) {
                    this.submit()
                } else {
                    this.updateDropdown();
                    this.focusInput();
                }

            },
            keyup(e) {
                // 8 = Backspace Key
                // 46 = Delete Key
                if (e.keyCode === 8 || e.keyCode === 46) {

                    if (this.token.value === null) {
                        this.$emit('token:remove', this.token);
                    } else if (this.token.value === "" || !this.token.value) {
                        this.token.value = null;
                    }
                }
                // return
                if (e.keyCode === 13) {
                    if (this.state.isDropdownEnabled === false) {
                        this.submit()
                    }
                }

            }
        },
        created: function () {

        },
        mounted: function () {
            if (this.isInput) {
                this.tokenInput = this.$refs.tokenInput;
                this.updateDropdown();
                this.focusInput();
            }
        },
        name: "VisualToken"
    }
</script>

<style lang="less" scoped>

    .token-type(@type,@basecolor) {
        &.token-type-@{type} {
            .name {
                background-color: @basecolor;
                color: inherit
            }

            .value-container {
                background-color: lighten(@basecolor, 10%);
                color: inherit
            }
        }
    }

    .js-visual-token {
        .token-type(category, #4389fe);

        &.token-type-category {
            color: #fff;
        }
    }

    .remove-token {
        font-size: 11px;
    }
</style>
